import React from 'react';
import { Grid, Typography, FormControl, Select, MenuItem, Button, makeStyles, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  formControl: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': { borderColor: 'rgba(0, 0, 0, 0.23)' },
      '&.Mui-focused fieldset': { borderColor: 'rgba(0, 0, 0, 0.23)' },
    },
  },
}));

const MFG_PLANT_OPTIONS = ['All', 'Greenville, NC, USA', 'Cincinnati, OH, USA', 'Durham, NC, USA'];
const BRAND_OPTIONS = ['All', 'Multiple Selection', 'Brand A', 'Brand B'];

const FilterSection = ({
  classes,
  cmoSite,
  setCmoSite,
  deliverableType,
  setDeliverableType,
  initialCmoSite,
  initialDeliverableType,
  cmoSitesList,
  deliverableTypesList,
  filtersLoading,
  handleSaveFilters,
  handleClearFilters,
  mfgPlant,
  setMfgPlant,
  brand,
  setBrand,
}) => {
  const localClasses = useStyles();

  const filterGroup = (label, content) => (
    <Grid
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        flexDirection: 'column',
        marginTop: '10px',
      }}
    >
      <Typography style={{ fontWeight: 'bold' }} className="dashboard-filter-labels">
        {label}
      </Typography>
      {content}
    </Grid>
  );

  return (
    <Grid
      item
      spacing={1}
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        gap: '0.5rem',
        alignItems: 'flex-end',
      }}
    >
      {/* CMO */}
      {filterGroup(
        'CMO:',
        <FormControl
          variant="outlined"
          size="small"
          style={{ width: '11rem', marginRight: '0.5rem' }}
          className={`dashboard-filter-dropdown ${localClasses.formControl}`}
        >
          <Autocomplete
            options={['All', ...cmoSitesList.map(s => (typeof s === 'object' ? s.siteNameFromReport : s))]}
            value={cmoSite === 'all' ? 'All' : cmoSite}
            selectOnFocus={false}
            onChange={(_, newValue) => {
              setCmoSite(!newValue || newValue === 'All' ? 'all' : newValue);
            }}
            getOptionLabel={o => o || ''}
            loading={filtersLoading}
            disabled={filtersLoading}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                placeholder={cmoSite === 'all' ? 'All' : 'Select CMO'}
                InputProps={{ ...params.InputProps, style: { height: '32px', padding: '0 8px' } }}
              />
            )}
          />
        </FormControl>
      )}

      {/* MFG Plant */}
      {filterGroup(
        'MFG Plant:',
        <FormControl
          variant="outlined"
          size="small"
          style={{ width: '13rem', marginRight: '0.5rem' }}
          className={`dashboard-filter-dropdown ${localClasses.formControl}`}
        >
          <Select
            value={mfgPlant}
            onChange={e => setMfgPlant(e.target.value)}
            style={{ height: '32px' }}
            displayEmpty
          >
            {MFG_PLANT_OPTIONS.map(opt => (
              <MenuItem key={opt} value={opt === 'All' ? 'all' : opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Brand */}
      {filterGroup(
        'Brand:',
        <FormControl
          variant="outlined"
          size="small"
          style={{ width: '11rem', marginRight: '0.5rem' }}
          className={`dashboard-filter-dropdown ${localClasses.formControl}`}
        >
          <Select
            value={brand}
            onChange={e => setBrand(e.target.value)}
            style={{ height: '32px' }}
            displayEmpty
          >
            {BRAND_OPTIONS.map(opt => (
              <MenuItem key={opt} value={opt === 'All' ? 'all' : opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Product Type */}
      {filterGroup(
        'Product Type:',
        <FormControl
          variant="outlined"
          size="small"
          style={{ width: '11rem', marginRight: '1rem' }}
          className={`dashboard-filter-dropdown ${localClasses.formControl}`}
        >
          <Select
            value={deliverableType}
            onChange={e => setDeliverableType(e.target.value)}
            style={{ height: '32px' }}
            disabled={filtersLoading}
            displayEmpty
          >
            <MenuItem value="all">All</MenuItem>
            {deliverableTypesList.map(type => {
              const name = typeof type === 'object' ? type.deliverableTypeName : type;
              return <MenuItem key={name} value={name}>{name}</MenuItem>;
            })}
          </Select>
        </FormControl>
      )}

      {/* Save filters */}
      <Grid style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', flexDirection: 'column' }}>
        <Button
          variant="contained"
          disableElevation
          disableRipple
          disableFocusRipple
          className={`${classes.stylebutton} dashboard-save-filter-btn`}
          onClick={handleSaveFilters}
          disabled={
            (cmoSite === initialCmoSite && deliverableType === initialDeliverableType) || filtersLoading
          }
          style={{ marginLeft: '8px', marginRight: '8px' }}
        >
          Save filters
        </Button>
      </Grid>

      {/* Clear all filters */}
      <Grid style={{ display: 'flex' }}>
        <Typography
          variant="caption"
          style={{ fontSize: '14px', color: 'blue', marginLeft: '8px', marginRight: '8px', cursor: 'pointer' }}
          className={classes.clearText}
          onClick={handleClearFilters}
        >
          Clear all filters
        </Typography>
      </Grid>
    </Grid>
  );
};

export default FilterSection;
